import { render, staticRenderFns } from "./SelectedStudyEnvironmentTimeAllocation.vue?vue&type=template&id=67804324&scoped=true"
import script from "./SelectedStudyEnvironmentTimeAllocation.vue?vue&type=script&lang=js"
export * from "./SelectedStudyEnvironmentTimeAllocation.vue?vue&type=script&lang=js"
import style0 from "./SelectedStudyEnvironmentTimeAllocation.vue?vue&type=style&index=0&id=67804324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67804324",
  null
  
)

export default component.exports